import PhotoSwipe from 'photoswipe';
import PhotoSwipeUIDefault from 'photoswipe/dist/photoswipe-ui-default.js';
import { datajs } from '../shared/utils';

export function initGlobalCaseGallery() {
	const parseGalleryImages = function (galleryImages) {
		const prepareImage = function (image) {
			let size = image.dataset.pswpSize.split('x');
			let item = {
				src: image.dataset.pswpImage,
				w: parseInt(size[0], 10),
				h: parseInt(size[1], 10),
			};

			let imageWrapper = image.closest('figure');
			let caption = imageWrapper?.querySelector('figcaption');
			let imageCaption = image?.dataset?.caption;

			if (caption && caption.innerText) {
				item.title = caption.innerText;
			} else if (imageCaption) {
				item.title = imageCaption;
			}

			return item;
		};

		const items = galleryImages.map((image) => prepareImage(image)) ?? [];

		return items;
	};

	const isGalleryImage = function (element) {
		if (element.dataset.pswpImage && element.classList.contains(galleryImageCssClass)) {
			return true;
		}

		return false;
	};

	const openPhotoSwipe = function (index) {
		const pswpElement = document.querySelectorAll('.pswp')[0];

		let gallery;

		if (index < 0) {
			index = 0;
		}

		// define options (if needed)
		const options = {
			index: index,
			showHideOpacity: true,
			getThumbBoundsFn: false,
		};

		// Pass data to PhotoSwipe and initialize it
		/* eslint-disable */
		gallery = new PhotoSwipe(pswpElement, PhotoSwipeUIDefault, preparedGalleryImages, options);
		/* eslint-enable */
		gallery.init();
		// Image loaded
		gallery.listen('imageLoadComplete', function (index, item) {
			item.container.classList.add('pswp__zoom-wrap--loaded');
		});
	};

	// triggers when user clicks on thumbnail
	const onThumbnailsClick = function (e) {
		let targetElement = e.target;

		// Handle case gallery images
		if (targetElement.classList.contains('m-caseGallerySlide')) {
			targetElement = targetElement.querySelector('img.' + galleryImageCssClass);
		}

		if (isGalleryImage(targetElement)) {
			openPhotoSwipe(galleryImages.indexOf(targetElement));
		}
	};

	const getGalleryImages = function () {
		return [...galleryElement.querySelectorAll('img.' + galleryImageCssClass)] ?? [];
	};

	// Only one large gallery on single case pages
	const galleryImageCssClass = 'pswp-gallery-image';
	const galleryElement = document.querySelector('#main-content');
	const galleryImages = getGalleryImages();
	const preparedGalleryImages = parseGalleryImages(galleryImages);

	if (galleryElement && preparedGalleryImages.length) {
		let galleryTriggerBtn = datajs('action-gallery');

		if (galleryTriggerBtn) {
			galleryTriggerBtn.classList.remove('d-none');
			galleryTriggerBtn.addEventListener('click', openPhotoSwipe);
		}

		galleryElement.addEventListener('click', onThumbnailsClick);
	}
}
